import { useEffect, useRef } from 'preact/hooks';
import { pushDismiss, removeDismiss } from '../../utils/escStack';

/**
 * Register a surface on the central Escape-dismiss stack while `open` is
 * true. LIFO stack order = on-screen layering: a menu opened over the cell
 * fan pops on the FIRST Escape, the fan on the second. Never both at once.
 * `onClose` is read through a ref so identity churn never re-pushes (which
 * would falsely promote the surface above later-opened ones).
 */
export function useEscDismiss(open, onClose) {
  const ref = useRef(onClose);
  ref.current = onClose;
  useEffect(() => {
    if (!open) return undefined;
    const id = pushDismiss(() => ref.current?.());
    return () => removeDismiss(id);
  }, [open]);
}
